"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocsTooltip = DocsTooltip;
var _react = _interopRequireWildcard(require("react"));
var _HelpCircle = _interopRequireDefault(require("mdi-material-ui/HelpCircle"));
var _core = require("@material-ui/core");
var _classnames = _interopRequireDefault(require("classnames"));
var _useClickHelpAPI2 = require("../../hooks/useClickHelpAPI");
var _DocsTooltipBody = require("./DocsTooltipBody");
var _BaseTooltip = require("../../baseComponents/BaseTooltip");
var _DocsTooltip = _interopRequireDefault(require("./DocsTooltip.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function DocsTooltip(_ref) {
  var _classNames;
  var topicId = _ref.topicId,
    _ref$linkTopicId = _ref.linkTopicId,
    linkTopicId = _ref$linkTopicId === void 0 ? '' : _ref$linkTopicId,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    _ref$customWidth = _ref.customWidth,
    customWidth = _ref$customWidth === void 0 ? 'auto' : _ref$customWidth,
    _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? 'default' : _ref$iconSize,
    _ref$showHeader = _ref.showHeader,
    showHeader = _ref$showHeader === void 0 ? false : _ref$showHeader,
    _ref$showFooter = _ref.showFooter,
    showFooter = _ref$showFooter === void 0 ? false : _ref$showFooter,
    dataId = _ref['data-id'];
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useClickHelpAPI = (0, _useClickHelpAPI2.useClickHelpAPI)(topicId, linkTopicId),
    data = _useClickHelpAPI.data,
    isLoading = _useClickHelpAPI.isLoading,
    error = _useClickHelpAPI.error;
  var classes = (0, _DocsTooltip.default)({
    customWidth: customWidth
  });
  var iconClasses = (0, _classnames.default)(classes.helpIcon, (_classNames = {}, _defineProperty(_classNames, classes.smallIcon, iconSize === 'small'), _defineProperty(_classNames, classes.helpIconActive, open), _classNames));
  var handleClose = function handleClose() {
    setOpen(false);
  };
  var toggleOpen = function toggleOpen() {
    setOpen(!open);
  };
  return /*#__PURE__*/_react.default.createElement(_core.ClickAwayListener, {
    onClickAway: handleClose
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_BaseTooltip.__BaseTooltip, {
    title: /*#__PURE__*/_react.default.createElement(_DocsTooltipBody.DocsTooltipBody, {
      isLoading: isLoading,
      error: error,
      data: data,
      classes: classes,
      showHeader: showHeader,
      showFooter: showFooter,
      linkTopicDataId: "".concat(dataId, "_learn_more_link")
    }),
    placement: placement,
    arrow: false,
    open: open,
    classes: {
      tooltip: classes.tooltip
    },
    interactive: true
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: toggleOpen,
    className: classes.helpIconBtn,
    "aria-label": "Click to view help docs",
    "data-id": dataId
  }, /*#__PURE__*/_react.default.createElement(_HelpCircle.default, {
    className: iconClasses
  })))));
}